import { render, staticRenderFns } from "./TabelaTotalComponent.vue?vue&type=template&id=e8662b9a"
import script from "./TabelaTotalComponent.vue?vue&type=script&lang=js"
export * from "./TabelaTotalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports